export { default } from "./NewsArticleHeader";
